// extracted by css-extract-rspack-plugin
export default {"dialog":"WebshopRequestController_dialog__BJQ4q"};